import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../../../src/lib/component-base';
import { handleFormInputValue } from '../../../../../../../redux/actions';
import ToggleSwitch from './children/ToggleSwitch';

const CODESHARE_NAME = 'IncludeCodeshares';
const CARGO_NAME = 'IncludeCargo';

@componentBase('QuerySelector')
export default class QuerySelector extends Component {
  static propTypes = {
    includeCodeshares: PropTypes.bool,
    includeCargo: PropTypes.bool,
    inputObjectDefaults: PropTypes.object,
  };

  toggleCodeshareState = (value) => {
    const { includeCodeshares } = this.props.inputObjectDefaults;
    const input = Object.assign({}, includeCodeshares, { value });
    this.dispatcher(handleFormInputValue(input));
  }

  toggleCargoState = (value) => {
    const { includeCargo } = this.props.inputObjectDefaults;
    const input = Object.assign({}, includeCargo, { value });
    this.dispatcher(handleFormInputValue(input));
  }

  get dispatcher() {
    return this.context.store.dispatch;
  }


  render() {
    const includeStyling = { textAlign: 'left', paddingLeft: '20px' };
    return (
      <div className='data-export-toggle-switches'>
        <div className='row codeshares-toggle'>
          <div className='col-xs-7'>
            <h5 style={includeStyling}>Include Codeshares?</h5>
          </div>
          <div className='col-xs-5'>
            <div className='row'>
              <div className='col-xs-3' >
                <h5>Yes</h5>
              </div>
              <div className='col-xs-5'>
                <ToggleSwitch
                  on={this.props.includeCodeshares}
                  name={CODESHARE_NAME}
                  onValue
                  offValue={false}
                  callback={this.toggleCodeshareState}
                />
              </div>
              <div className='col-xs-4' >
                <h5 className='no-text'>No</h5>
              </div>
            </div>
          </div>
        </div>
        <div className='row cargos-toggle'>
          <div className='col-xs-7'>
            <h5 style={includeStyling}>Include Cargo<span className='hidden-xs hidden-sm hidden-md'> Freighter</span>?</h5>
          </div>
          <div className='col-xs-5'>
            <div className='row'>
              <div className='col-xs-3' >
                <h5>Yes</h5>
              </div>
              <div className='col-xs-5'>
                <ToggleSwitch
                  on={this.props.includeCargo}
                  name={CARGO_NAME}
                  onValue
                  offValue={false}
                  callback={this.toggleCargoState}
                />
              </div>
              <div className='col-xs-4' >
                <h5 className='no-text'>No</h5>
              </div>
            </div>
          </div>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/AirlineSelections/children/QuerySelector.js